import { TIME_IN_MS } from 'constants/dateTime';
import { FIRST_TRADE_GTM_TRACKING_START_DATE } from 'constants/gtmTracking';

import { timeNow, toUTC } from './day';

type GtmEventTrackingUtils<E, X extends (...args: any[]) => boolean> = {
  needToFetchEventsData: boolean;
  shouldTrack: X;
  eventValuesFormatter(eventValues: E): object;
};

const FourteenDayCommissionUtils: GtmEventTrackingUtils<
  {
    commission: string | number;
    shouldTrackCriteoEvents: boolean;
    inrConversionRate: number;
  },
  (
    isFirstTradeGtmTracked?: boolean,
    isFourteenDaysCommissionTracked?: boolean,
    firstTradeTime?: string | null
  ) => boolean
> = {
  needToFetchEventsData: true,
  shouldTrack: (
    isFirstTradeGtmTracked,
    isFourteenDaysCommissionTracked,
    firstTradeTime
  ) => {
    if (!isFirstTradeGtmTracked) return false;
    if (isFourteenDaysCommissionTracked) return false;

    if (!firstTradeTime) return false;

    return (
      timeNow().valueOf() > toUTC(firstTradeTime).valueOf() + TIME_IN_MS.ONE_DAY * 14
    );
  },
  eventValuesFormatter(data) {
    return {
      totalTradeCommission:
        (Math.abs(Number(data.commission)) * data.inrConversionRate) / 10,
      shouldTrackCriteoTrigger: data.shouldTrackCriteoEvents,
    };
  },
};

const FirstTradeUtils: GtmEventTrackingUtils<
  {
    commission: string | number;
    shouldTrackCriteoEvents: boolean;
    inrConversionRate: number;
  },
  (
    isFirstTradeGtmTracked,
    registeredDate?: string,
    hasDoneFirstTrade?: boolean
  ) => boolean
> = {
  needToFetchEventsData: true,
  shouldTrack: (
    isFirstTradeGtmTracked,
    registeredDate?: string,
    hasDoneFirstTrade?: boolean
  ) => {
    if (!hasDoneFirstTrade || !registeredDate) return false;

    const registeredDateObject = toUTC(registeredDate);

    if (!registeredDateObject.isValid()) return false;

    return (
      !isFirstTradeGtmTracked &&
      registeredDateObject.valueOf() > FIRST_TRADE_GTM_TRACKING_START_DATE.valueOf()
    );
  },
  eventValuesFormatter(data) {
    return {
      firstTradeCommission:
        (Math.abs(Number(data.commission)) * data.inrConversionRate) / 10,
      shouldTrackCriteoTrigger: data.shouldTrackCriteoEvents,
    };
  },
};

export { FirstTradeUtils, FourteenDayCommissionUtils };
